"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _makeDecoratorDisplayName = _interopRequireDefault(require("reference-resolvers/lib/makeDecoratorDisplayName"));

var _enforce = require("reference-resolvers/lib/enforce");

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _curry = _interopRequireDefault(require("transmute/curry"));

var _map = _interopRequireDefault(require("transmute/map"));

var _forEach = _interopRequireDefault(require("transmute/forEach"));

var _bind = _interopRequireDefault(require("transmute/bind"));

var _atom = require("atom");

var _SymbolObjectSet = _interopRequireDefault(require("reference-resolvers/lib/SymbolObjectSet"));

var _utils = require("reference-resolvers/utils");

var _ReferenceResolversContext = require("./ReferenceResolversContext");

var _withReferenceResolverContext = _interopRequireDefault(require("./withReferenceResolverContext"));

var unresolvedSymbol = Symbol('unresolved');

var mapAtoms = function mapAtoms(fn, structure) {
  if ((0, _atom.isAtom)(structure) || structure === unresolvedSymbol) {
    return fn(structure);
  } else {
    return (0, _map.default)(function (child) {
      return mapAtoms(fn, child);
    }, structure);
  }
};

var forEachAtom = function forEachAtom(fn, structure) {
  if (structure === unresolvedSymbol) {
    return;
  }

  if ((0, _atom.isAtom)(structure)) {
    fn(structure);
  } else {
    (0, _forEach.default)(function (child) {
      return forEachAtom(fn, child);
    }, structure);
  }
};

var isSimpleObject = function isSimpleObject(object) {
  if (object == null) {
    return false;
  }

  var proto = Object.getPrototypeOf(object);
  return proto === Object.prototype;
};
/**
 * Accepts a reference object type (checkout reference-resolvers/constants/ReferenceObjectType)
 * and a function to map the resolver to the components props.
 *
 * @param {String} referenceObjectType
 * @param {Function} mapResolverToAtoms
 * @param {React.Component | Function} Component
 * @return {React.Component} The decorated component
 */


var ResolveReferences = function ResolveReferences(mapResolversToAtoms, Component) {
  (0, _enforce.enforceFunction)('mapResolverToAtoms', mapResolversToAtoms);
  (0, _enforce.enforceReactComponent)('Component', Component);

  var getAtomStructure = function getAtomStructure(resolvers, props) {
    var result = mapResolversToAtoms(resolvers, props, unresolvedSymbol);
    (0, _invariant.default)(isSimpleObject(result), 'expected `mapResolverToAtoms` to return a simple object, but got `%s`', result);
    return result;
  };

  var WithReferences =
  /*#__PURE__*/
  function (_React$Component) {
    (0, _inherits2.default)(WithReferences, _React$Component);

    function WithReferences() {
      var _getPrototypeOf2;

      var _this;

      (0, _classCallCheck2.default)(this, WithReferences);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(WithReferences)).call.apply(_getPrototypeOf2, [this].concat(args)));
      _this.watchAtom = (0, _bind.default)(_this.watchAtom, (0, _assertThisInitialized2.default)(_this));
      _this.unwatchAtom = (0, _bind.default)(_this.unwatchAtom, (0, _assertThisInitialized2.default)(_this));
      _this.handleReferenceUpdate = (0, _bind.default)(_this.handleReferenceUpdate, (0, _assertThisInitialized2.default)(_this));
      return _this;
    }

    (0, _createClass2.default)(WithReferences, [{
      key: "componentWillMount",
      value: function componentWillMount() {
        var resolvers = this.props.referenceResolverContext || {};
        this._atomStructure = getAtomStructure(resolvers, this.props);
        this._lastAtoms = new _SymbolObjectSet.default();
        this._currentAtoms = new _SymbolObjectSet.default();
        forEachAtom(this.watchAtom, this._atomStructure);
        this.handleReferenceUpdate();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this._currentAtoms.forEach(this.unwatchAtom);
      }
    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        var resolvers = this.props.referenceResolverContext || {};
        this._atomStructure = getAtomStructure(resolvers, nextProps);
        this.updateAtoms(this._atomStructure);
        this.handleReferenceUpdate();
      }
    }, {
      key: "updateAtoms",
      value: function updateAtoms(atoms) {
        this._lastAtoms = this._currentAtoms;
        this._currentAtoms = new _SymbolObjectSet.default();
        forEachAtom(this.watchAtom, atoms);

        this._lastAtoms.forEach(this.unwatchAtom);

        this._lastAtoms = null;
      }
    }, {
      key: "watchAtom",
      value: function watchAtom(atom) {
        if (atom === unresolvedSymbol) {
          return;
        }

        if (this._lastAtoms.has(atom)) {
          this._lastAtoms.remove(atom);
        } else {
          (0, _atom.watch)(atom, this.handleReferenceUpdate);
        }

        this._currentAtoms.add(atom);
      }
    }, {
      key: "unwatchAtom",
      value: function unwatchAtom(atom) {
        (0, _atom.unwatch)(atom, this.handleReferenceUpdate);
      }
    }, {
      key: "handleReferenceUpdate",
      value: function handleReferenceUpdate() {
        var unresolved = [];

        var derefGetUnresolved = function derefGetUnresolved(atom) {
          if (atom === unresolvedSymbol) {
            return unresolved;
          }

          var value = (0, _atom.deref)(atom);

          if (!(0, _utils.isResolved)(value)) {
            unresolved.push(value);
          }

          return value;
        };

        this.setState({
          resolved: mapAtoms(derefGetUnresolved, this._atomStructure)
        });
      }
    }, {
      key: "render",
      value: function render() {
        var resolved = this.state.resolved;
        var _this$props = this.props,
            __resolvers = _this$props.referenceResolverContext,
            rest = (0, _objectWithoutProperties2.default)(_this$props, ["referenceResolverContext"]);
        return _react.default.createElement(Component, (0, _extends2.default)({}, rest, resolved));
      }
    }]);
    return WithReferences;
  }(_react.default.Component);

  WithReferences.propTypes = (0, _extends2.default)({}, _ReferenceResolversContext.referenceResolverContextPropTypes);
  var ContextConnector = (0, _withReferenceResolverContext.default)(WithReferences);
  ContextConnector.displayName = (0, _makeDecoratorDisplayName.default)("ResolveReferences", Component);
  ContextConnector.WrappedComponent = Component;
  return ContextConnector;
};

var _default = (0, _curry.default)(ResolveReferences);

exports.default = _default;
module.exports = exports.default;